// useFechaFiltro.js

import { useState, useCallback } from "react";
import moment from "moment";

const useFechaFiltro = () => {
    // 1. Estados de control inicializados con la fecha/hora local actual
    const [filtro, setFiltro] = useState("dia");
    const [fechaSeleccionada, setFechaSeleccionada] = useState(moment().format('YYYY-MM-DD'));
    const [horaSeleccionada, setHoraSeleccionada] = useState(moment().format('HH:mm'));
    const [semanaSeleccionada, setSemanaSeleccionada] = useState(moment().format('GGGG-[W]WW'));
    const [mesSeleccionado, setMesSeleccionado] = useState(moment().format('YYYY-MM'));
    const [anioSeleccionado, setAnioSeleccionado] = useState(moment().year());

    // 2. Lógica para obtener las fechas de inicio y fin (reutilizable y matemáticamente exacta)
    const obtenerFechasDeFiltro = useCallback(() => {
        let mInicio, mFin;

        switch (filtro) {
            case "dia": {
                const f = fechaSeleccionada || moment().format('YYYY-MM-DD');
                mInicio = moment(f, 'YYYY-MM-DD').startOf('day');
                mFin = moment(f, 'YYYY-MM-DD').endOf('day');
                break;
            }
            case "dia-hora": {
                const f = fechaSeleccionada || moment().format('YYYY-MM-DD');
                const h = horaSeleccionada || moment().format('HH:mm');
                // Tomar la hora/minuto seleccionada y cubrir 1 hora exacta (ej. 11:15:00 a 12:14:59)
                mInicio = moment(`${f} ${h}`, 'YYYY-MM-DD HH:mm');
                mFin = mInicio.clone().add(1, 'hour').subtract(1, 'second');
                break;
            }
            case "semana": {
                const s = semanaSeleccionada || moment().format('GGGG-[W]WW');
                mInicio = moment(s, 'GGGG-[W]WW').startOf('isoWeek'); // Lunes 00:00:00
                mFin = mInicio.clone().endOf('isoWeek');               // Domingo 23:59:59 (7 días exactos)
                break;
            }
            case "mes": {
                const m = mesSeleccionado || moment().format('YYYY-MM');
                mInicio = moment(m, 'YYYY-MM').startOf('month');      // Día 1 a las 00:00:00
                mFin = mInicio.clone().endOf('month');                // Último día del mes a las 23:59:59
                break;
            }
            case "año": {
                const a = parseInt(anioSeleccionado, 10) || moment().year();
                mInicio = moment().year(a).startOf('year');           // 1 de Enero 00:00:00
                mFin = mInicio.clone().endOf('year');                 // 31 de Diciembre 23:59:59
                break;
            }
            default: {
                mInicio = moment().startOf('day');
                mFin = moment().endOf('day');
                break;
            }
        }

        return {
            fechaInicio: mInicio.toDate(),
            fechaFin: mFin.toDate(),
            fechaInicioFormato: mInicio.format('YYYY-MM-DD HH:mm:ss'),
            fechaFinFormato: mFin.format('YYYY-MM-DD HH:mm:ss'),
        };
    }, [filtro, fechaSeleccionada, horaSeleccionada, semanaSeleccionada, mesSeleccionado, anioSeleccionado]);

    // 3. Devolver los estados, setters y la lógica de fechas
    return {
        filtro, setFiltro,
        fechaSeleccionada, setFechaSeleccionada,
        horaSeleccionada, setHoraSeleccionada,
        semanaSeleccionada, setSemanaSeleccionada,
        mesSeleccionado, setMesSeleccionado,
        anioSeleccionado, setAnioSeleccionado,
        obtenerFechasDeFiltro,
        maxAnio: moment().year(), // Propiedad auxiliar
    };
};

export default useFechaFiltro;
